var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1186 27.8548H30.957C30.7882 27.8548 30.6476 27.9954 30.6476 28.1642V30.6472H5.34717V5.34275H30.6516V7.82578C30.6516 7.99453 30.7923 8.13516 30.961 8.13516H33.1226C33.2914 8.13516 33.432 7.99855 33.432 7.82578V3.79989C33.432 3.11685 32.8816 2.56641 32.1985 2.56641H3.80431C3.12128 2.56641 2.57083 3.11685 2.57083 3.79989V32.1901C2.57083 32.8731 3.12128 33.4236 3.80431 33.4236H32.1945C32.8775 33.4236 33.428 32.8731 33.428 32.1901V28.1642C33.428 27.9914 33.2874 27.8548 33.1186 27.8548ZM33.6691 16.5486H21.053V13.495C21.053 13.2258 20.7396 13.0731 20.5307 13.2419L14.8293 17.7419C14.7909 17.7719 14.7598 17.8103 14.7385 17.8542C14.7171 17.8981 14.706 17.9462 14.706 17.995C14.706 18.0438 14.7171 18.0919 14.7385 18.1358C14.7598 18.1796 14.7909 18.218 14.8293 18.2481L20.5307 22.7481C20.7436 22.9169 21.053 22.7642 21.053 22.495V19.4414H33.6691C33.8458 19.4414 33.9905 19.2968 33.9905 19.12V16.87C33.9905 16.6932 33.8458 16.5486 33.6691 16.5486Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.0af9a88b.svg";
export { ForwardRef as ReactComponent };